module.exports = __webpack_public_path__ + "static/media/message-send-btn.f4e62293.svg";